import { canRead, canWrite } from '../access/rbacAccess'

export const RBAC_MANAGEMENT = {
  USERS: 'planifica.rbac.users',
  ROLES: 'planifica.rbac.roles'
}

export const canViewRbacUsers = () => canRead(RBAC_MANAGEMENT.USERS)

export const canManageRbacUsers = () => canWrite(RBAC_MANAGEMENT.USERS)

export const canViewRbacRoles = () => canRead(RBAC_MANAGEMENT.ROLES)

export const canManageRbacRoles = () => canWrite(RBAC_MANAGEMENT.ROLES)
